// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.videos-result {
  position: relative;
}
.videos-result [class^=dist_Alert] {
  margin-bottom: 16px;
}

.title {
  display: flex;
  align-items: center;
}
.title .tooltip-wrapper {
  margin-left: 8px;
}

.videos-grid-wrapper .loading-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.videos-grid-wrapper .search-page-no-results h1 {
  color: var(--color_primary_500);
  text-align: center;
}
.videos-grid-wrapper .infinite-wrapper .loading-component {
  padding: 0 0 150px;
}
.videos-grid-wrapper .search-videos-count h2 {
  margin: 0;
  line-height: 1;
}
.videos-grid-wrapper .search-videos-count > span {
  font-size: 24px;
  font-weight: 600;
}
.videos-grid-wrapper .filters-grid {
  display: flex;
  justify-content: flex-end;
}
.videos-grid-wrapper .filters-grid > * {
  margin: 0 0 0 20px;
}
.videos-grid-wrapper .filters-grid .input-action-container .input-wrapper {
  background: none;
}
.videos-grid-wrapper .filters-grid .input-action-container .input-wrapper input {
  background: none;
  font-size: 14px;
  padding: 9px;
}
.videos-grid-wrapper .videos-list-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1;
  background: var(--background);
  border-radius: 4px;
  font-weight: bold;
  display: grid;
  grid-template-columns: 36px 26px 142px 1fr 100px 100px 100px 100px;
  grid-column-gap: 16px;
  padding: 0 8px;
  margin: 0 0 8px;
  align-items: center;
  justify-items: left;
  height: 36px;
  color: var(--gray_dark2);
  font-size: 12px;
}
.videos-grid-wrapper .videos-list-header .list-header-tooltip {
  display: flex;
  align-items: center;
}
.videos-grid-wrapper .videos-list-header .list-header-tooltip .QuestionMarkTooltip {
  margin-left: 8px;
}
.videos-grid-wrapper .videos-grid {
  justify-content: center;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  grid-gap: 40px 20px;
}
.videos-grid-wrapper .video-grid-see-more-card {
  height: 173px;
}

.video-player-content {
  padding: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/VideosGrid/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,mBAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;AAAF;AAEE;EACE,gBAAA;AAAJ;;AAKE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAFJ;AAMI;EACE,+BAAA;EACA,kBAAA;AAJN;AASI;EACE,kBAAA;AAPN;AAYI;EACE,SAAA;EACA,cAAA;AAVN;AAaI;EACE,eAAA;EACA,gBAAA;AAXN;AAeE;EACE,aAAA;EACA,yBAAA;AAbJ;AAeI;EACE,kBAAA;AAbN;AAgBI;EACE,gBAAA;AAdN;AAgBM;EACE,gBAAA;EACA,eAAA;EACA,YAAA;AAdR;AAmBE;EACE,wBAAA;EAAA,gBAAA;EACA,MAAA;EACA,UAAA;EACA,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,kEAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;AAjBJ;AAmBI;EACE,aAAA;EACA,mBAAA;AAjBN;AAmBM;EACE,gBAAA;AAjBR;AAsBE;EACE,uBAAA;EACA,aAAA;EACA,4DAAA;EACA,mBAAA;AApBJ;AAuBE;EACE,aAAA;AArBJ;;AAyBA;EACE,aAAA;AAtBF","sourcesContent":[".videos-result {\n  position: relative;\n\n  [class^='dist_Alert'] {\n    margin-bottom: 16px;\n  }\n}\n\n.title {\n  display: flex;\n  align-items: center;\n\n  .tooltip-wrapper {\n    margin-left: 8px;\n  }\n}\n\n.videos-grid-wrapper {\n  .loading-wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n\n  .search-page-no-results {\n    h1 {\n      color: var(--color_primary_500);\n      text-align: center;\n    }\n  }\n\n  .infinite-wrapper {\n    .loading-component {\n      padding: 0 0 150px;\n    }\n  }\n\n  .search-videos-count {\n    h2 {\n      margin: 0;\n      line-height: 1;\n    }\n\n    & > span {\n      font-size: 24px;\n      font-weight: 600;\n    }\n  }\n\n  .filters-grid {\n    display: flex;\n    justify-content: flex-end;\n\n    > * {\n      margin: 0 0 0 20px;\n    }\n\n    .input-action-container .input-wrapper {\n      background: none;\n\n      input {\n        background: none;\n        font-size: 14px;\n        padding: 9px;\n      }\n    }\n  }\n\n  .videos-list-header {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    background: var(--background);\n    border-radius: 4px;\n    font-weight: bold;\n    display: grid;\n    grid-template-columns: 36px 26px 142px 1fr 100px 100px 100px 100px;\n    grid-column-gap: 16px;\n    padding: 0 8px;\n    margin: 0 0 8px;\n    align-items: center;\n    justify-items: left;\n    height: 36px;\n    color: var(--gray_dark2);\n    font-size: 12px;\n\n    .list-header-tooltip {\n      display: flex;\n      align-items: center;\n\n      .QuestionMarkTooltip {\n        margin-left: 8px;\n      }\n    }\n  }\n\n  .videos-grid {\n    justify-content: center;\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    grid-gap: 40px 20px;\n  }\n\n  .video-grid-see-more-card {\n    height: 173px;\n  }\n}\n\n.video-player-content {\n  padding: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
